/**
 * authorization redux selectors (mostly deprecated)
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


/* deprectated import {ACCESS_HIDDEN, ACCESS_READONLY, ACCESS_WRITABLE, getAccessibilityLevel} from './consts';*/


/**
 * select all roles of the given ones, the current user belongs to
 * @param {Object} state            authorization state
 * @param {string} typeId           object type ID
 * @returns {boolean}               true if user is allowed to create objects of the given type, otherwise false
 * @author Jens Gruschel
 */
export function selectTypeCreatable(state, typeId) {

    if (!state.typeInfo) return false;
    const typeInfo = state.typeInfo[typeId];
    return typeInfo && typeInfo.creatable;
}

/**
 * select predefined access level (1, 2, 3) of object type for current user
 * @param {Object} state            authorization state
 * @param {string} typeId           object type ID
 * @returns {number}                access level 1 ("hidden"), 2 ("readonly") or 3 ("writable") for said object type
 * @author Jens Gruschel
 */
/* deprectated function selectTypeAccessLevel(state, typeId) {

    if (!state.typeInfo) return ACCESS_HIDDEN;
    const typeInfo = state.typeInfo[typeId];
    return typeInfo ? typeInfo.accesslevel : ACCESS_HIDDEN;
}*/

/**
 * select all roles of the given ones, the current user belongs to
 * @param {Object} state            authorization state
 * @param {Array} roles             array of roles interested in
 * @returns {Array}                 all roles of the given ones the current user belongs to or an empty array otherwise
 * @author Jens Gruschel
 */
/* deprectated function selectUserMembership(state, roles) {
    if (!roles || roles.length === 0) return [];
    if (!state.userInfo) return [];
    const userRoles = state.userInfo.roles;
    if (!userRoles) return [];
    return roles.filter(role => userRoles.includes(role));
}*/

/**
 * get level (1, 2, 3) for access object
 * @param {Object} state            authorization state
 * @param {Object} access           access object
 * @param {number} basicAccessLevel maximum access level used if not stated otherwise
 * @returns {number}                level 1 ("hidden"), 2 ("readonly") or 3 ("writable")
 * @author Jens Gruschel
 */
/* deprectated function getAccessLevel(state, access, basicAccessLevel) {

    if (!access) return basicAccessLevel;

    const accessLevel = getAccessibilityLevel(access.accessibility);
    
    // compute total level
    const totalLevel = Math.min(basicAccessLevel, accessLevel);

    // grant write access if explicitly given for user role (or level already reached)
    if (totalLevel >= ACCESS_WRITABLE) return totalLevel;
    if (selectUserMembership(state, access.writableFor).length > 0) return ACCESS_WRITABLE;

    // grant read access if explicitly given for user role (or level already reached)
    if (totalLevel >= ACCESS_READONLY) return totalLevel;
    if (selectUserMembership(state, access.readableFor).length > 0) return ACCESS_READONLY;

    // return level computed earlier
    return totalLevel;
}*/

/**
 * select access level (1, 2, 3) of concrete object for current user
 * @param {Object} state            authorization state
 * @param {Object} object           object
 * @returns {number}                access level 1 ("hidden"), 2 ("readonly") or 3 ("writable") for said object
 * @author Jens Gruschel
 */
/* deprectated function selectObjectAccessLevel(state, object) {

    if (!state.userInfo) return ACCESS_HIDDEN;
    if (!object) return ACCESS_HIDDEN;

    // grant full access to the owner (creator) of an object
    const owner = object["user-created"];
    if (owner === state.userInfo.id) return ACCESS_WRITABLE;

    // compute access level for the object type
    const typeAccessLevel = selectTypeAccessLevel(state, object.type);

    // compute access level for the concrete object instance (if defined)
    if (object.objectaccess && object.objectaccess.accessibility) {
        return getAccessLevel(state, object.objectaccess, typeAccessLevel);
    }
    else {
        return typeAccessLevel;
    }
}*/

/**
 * select access level (1, 2, 3) of specific field set for current user
 * @param {Object} state                authorization state
 * @param {Object} fieldSet             field set definitions
 * @param {number} objectAccessLevel    object access level (evaluated before) used if access is not defined explicitly for this field set
 * @returns {number}                    access level 1 ("hidden"), 2 ("readonly") or 3 ("writable") for said object
 * @author Jens Gruschel
 */
/* deprectated function selectFieldSetAccessLevel(state, fieldSet, objectAccessLevel) {

    if (!state.userInfo) return ACCESS_HIDDEN;
    if (!fieldSet) return ACCESS_HIDDEN;

    // compute access level for the concrete object instance (if defined)
    if (fieldSet.access && fieldSet.access.accessibility) {
        return getAccessLevel(state, fieldSet.access, objectAccessLevel);
    }
    else {
        return objectAccessLevel;
    }
} */